import { isEmpty } from "lodash"
import React, { useEffect, useState } from "react"
import { Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import CheckIcon from "../../assets/check.svg"
import TrashIcon from "../../assets/trash.svg"
import { CHANGE_TYPE, SERVICE_TYPE } from "../../constants/constants"
import ArrowDown from "./ArrowDown.svg"
import ArrowDownFilled from "./ArrowDownFilled.svg"
import ArrowUp from "./ArrowUp.svg"
import ArrowUpFilled from "./ArrowUpFilled.svg"

const CreateOrUpdateSurchrage = ({
    surchargeData,
    setSurchargeData,
    handleDeletingSurcharge,
    error,
    setError,
    shippingRateDetails,
    calculateTotalSurcharges,
    bulkUpdate = false,
    surcharges,
    setSurcharges
}: {
    surchargeData: Record<string, any>
    setSurchargeData: Function
    handleDeletingSurcharge?: Function
    error: string
    setError: Function
    shippingRateDetails?: Record<string, any>
    calculateTotalSurcharges?: Function
    bulkUpdate?: boolean
    surcharges: Record<string, any>[]
    setSurcharges: Function
}) => {
    const { t } = useTranslation()
    const [surchargeSuccess, setSurchargeSuccess] = useState(false)

    useEffect(() => {
        if (surchargeSuccess) {
            setSurcharges([...surcharges?.filter((s) => s?.id !== surchargeData?.id), surchargeData])
            setSurchargeData({})
            setSurchargeSuccess(false)
        }
    }, [surchargeSuccess])

    return (
        <tr className="rounded">
            <td className={bulkUpdate ? "col-3" : "col-4"}>
                <Form.Control
                    id="surchargeName"
                    type="text"
                    autoComplete="off"
                    name={"name"}
                    value={surchargeData?.name || ""}
                    disabled
                    onChange={(e: any) => {
                        if (e.target.value !== "") {
                            setError("")
                        } else {
                            setError("Surcharge Name is required.")
                        }
                        setSurchargeData({
                            ...surchargeData,
                            name: e.target.value
                        })
                    }}
                    placeholder="Name"
                    isInvalid={error !== ""}
                />
                {/* {error && error !== "" && <Form.Control.Feedback type="invalid">
                {t(`${error}`)}
            </Form.Control.Feedback>
            } */}
            </td>
            <td className="col-3">
                <Form.Control
                    id="defaultValue"
                    type="number"
                    autoComplete="off"
                    name={"default_value"}
                    value={surchargeData?.default_value}
                    onChange={(e: any) => {
                        // if (parseFloat(e.target.value) > 0) {
                        //     setError("")
                        // } else {
                        //     setError("Default value of a surcharge shouldn't be 0.")
                        // }
                        if (calculateTotalSurcharges && shippingRateDetails) {
                            const surchargeValue =
                                surchargeData?.type === SERVICE_TYPE["0"]
                                    ? parseFloat(e.target.value) || 0
                                    : ((parseFloat(e.target.value) || 0) / 100) *
                                      parseFloat(shippingRateDetails?.base_charge)
                            const surchargeOldValue =
                                surchargeData?.type === SERVICE_TYPE["0"]
                                    ? parseFloat(surchargeData?.default_value)
                                    : (parseFloat(surchargeData?.default_value) / 100) *
                                      parseFloat(shippingRateDetails?.base_charge)

                            calculateTotalSurcharges(
                                parseFloat(surchargeValue?.toFixed(2)),
                                "ADDED_SURCHARGE",
                                parseFloat(surchargeOldValue?.toFixed(2)),
                                false
                            )
                        }
                        setSurchargeData({
                            ...surchargeData,
                            default_value: parseFloat(e.target.value || 0)
                        })
                    }}
                    placeholder="Value"
                    // isInvalid={error !== ""}
                />
                {/* {error && error !== "" && <Form.Control.Feedback type="invalid">
                {t(`${error}`)}
            </Form.Control.Feedback>
            } */}
            </td>
            <td className={bulkUpdate ? "col-2" : "col-3"}>
                <Form.Check
                    type="radio"
                    name="type"
                    label={t("Flat")}
                    onChange={(e: any) => {
                        if (calculateTotalSurcharges && shippingRateDetails) {
                            const oldValue =
                                (parseFloat(surchargeData.default_value) / 100) *
                                shippingRateDetails?.base_charge
                            calculateTotalSurcharges(
                                parseFloat(surchargeData?.default_value),
                                "ADDED_SURCHARGE",
                                parseFloat(oldValue?.toFixed(2)),
                                false
                            )
                        }
                        setSurchargeData({
                            ...surchargeData,
                            type: SERVICE_TYPE["0"],
                            default_type: SERVICE_TYPE["0"]
                        })
                    }}
                    required={true}
                    checked={surchargeData?.type === SERVICE_TYPE["0"]}
                />
                <Form.Check
                    type="radio"
                    name="type"
                    label={t("Percentage")}
                    onChange={(e: any) => {
                        if (calculateTotalSurcharges && shippingRateDetails) {
                            const newValue =
                                (parseFloat(surchargeData.default_value) / 100) *
                                shippingRateDetails?.base_charge
                            calculateTotalSurcharges(
                                parseFloat(newValue?.toFixed(2)),
                                "ADDED_SURCHARGE",
                                parseFloat(surchargeData?.default_value),
                                false
                            )
                        }
                        setSurchargeData({
                            ...surchargeData,
                            type: SERVICE_TYPE["1"],
                            default_type: SERVICE_TYPE["1"]
                        })
                    }}
                    required={true}
                    checked={surchargeData?.type === SERVICE_TYPE["1"]}
                />
            </td>
            {bulkUpdate && (
                <td className="col-2">
                    <div className="border rounded d-flex p-1 w-fit-content">
                        <img
                            src={
                                !surchargeData?.action_type || surchargeData?.action_type === CHANGE_TYPE["0"]
                                    ? ArrowUpFilled
                                    : ArrowUp
                            }
                            className={"rounded tr-pointer"}
                            onClick={() =>
                                setSurchargeData({ ...surchargeData, action_type: CHANGE_TYPE["0"] })
                            }
                        />
                        &nbsp;
                        <img
                            src={surchargeData?.action_type === CHANGE_TYPE["1"] ? ArrowDownFilled : ArrowDown}
                            className={"rounded tr-pointer"}
                            onClick={() =>
                                setSurchargeData({ ...surchargeData, action_type: CHANGE_TYPE["1"] })
                            }
                        />
                    </div>
                </td>
            )}
            <td className="col-2 d-flex justify-content-start">
                <img
                    src={CheckIcon}
                    className="tr-pointer w-25"
                    onClick={() => {
                        if (!isEmpty(surchargeData)) {
                            setSurchargeSuccess(true)
                        }
                    }}
                />
                <img
                    src={TrashIcon}
                    className="tr-pointer w-25 ml-2"
                    onClick={() => {
                        if (calculateTotalSurcharges && shippingRateDetails) {
                            if (surchargeData?.id && handleDeletingSurcharge) {
                                const surchargeValue =
                                    surchargeData?.type === SERVICE_TYPE["0"]
                                        ? parseFloat(surchargeData?.default_value) || 0
                                        : ((parseFloat(surchargeData?.default_value) || 0) / 100) *
                                          parseFloat(shippingRateDetails?.base_charge)
                                calculateTotalSurcharges(
                                    parseFloat(surchargeValue?.toFixed(2)),
                                    "REMOVED_SURCHARGE",
                                    0,
                                    false
                                )
                                handleDeletingSurcharge(surchargeData?.id)
                            }
                        }
                        setSurchargeData({})
                    }}
                />
            </td>
        </tr>
    )
}

export default CreateOrUpdateSurchrage
